import React, { Component } from 'react'
import { PageContainer } from '@toolpad/core/PageContainer'
import CustomerTable from '../../../components/admin_portal/customer/CustomerTable'
import CreateCustomer from '../../../components/admin_portal/customer/CreateCustomer'
import CustomerPageToolbar from '../../../components/admin_portal/customer/CustomerPageToolbar'

export class CustomerContainer extends Component {

  handleCustomerModal = (newVal, c_action) => {
    this.props.setCustomerModalOpen(newVal);
    this.props.setAction(c_action)
  }

  handleCustomerUpdateModal = async (newVal, c_action, customer_id) => {
    let res = await this.props.get_customer_details(customer_id)
    if (res && !res.error) {
      this.props.setCustomerModalOpen(newVal);
      this.props.setAction(c_action)
      this.props.setId(customer_id)
    }
  };

  handleCustomerSubmit = async (payload) => {
    let res = await this.props.create_customer(payload);
    return res;
  };

  handleCustomerUpdate = async (payload) => {
    let res = await this.props.update_customer(payload);
    return res;
  };

  handleActivateDeactivateCustomer = async (payload) => {
    let res = await this.props.activate_deactivate_customer(payload);
    return res;
  };

  render() {
    const {
      is_customer_modal_open,
      common_loading,
      total_customer_count,
      active_customer,
      page,
      c_action,
      customer_id,
      selected_data,
    } = this.props;
    return (
      <PageContainer maxWidth='xl' slots={{
        toolbar: CustomerPageToolbar,
      }} title={""}
        sx={{
          '& .css-lc31tn > .MuiTypography-h4': {
            fontSize: '14px',
            alignSelf: { md: 'center', xs: 'flex-start' },
          },
          '& .css-lc31tn': {
            bgcolor: theme => theme.palette.grey[200],
            px: 1.5,
            py: 0.1,
            borderRadius: '10px',
            my: 1.5,
            flexDirection: { md: 'row', xs: 'column' },
            alignItems: { md: 'unset', xs: 'flex-start' }
          },
          '& .css-1hwxlk6': {
            width: { md: 'unset', xs: '100%' },
            flexDirection: { md: 'row', xs: 'column' },
            marginLeft: { md: 'auto', xs: 'unset!important' }
          },
        }}>
        <CustomerTable
          total_customer_count={total_customer_count}
          is_loading={common_loading}
          page={page}
          is_customer_modal_open={is_customer_modal_open}
          handleCustomerUpdateModal={this.handleCustomerUpdateModal}
          activate_deactivate_customer={this.handleActivateDeactivateCustomer}
        />
        <CreateCustomer
          is_customer_modal_open={is_customer_modal_open}
          handleCustomerModal={this.handleCustomerModal}
          handleCustomerSubmit={this.handleCustomerSubmit}
          handleCustomerUpdate={this.handleCustomerUpdate}
          is_loading={common_loading}
          c_action={c_action}
          customer_id={customer_id}
          selected_data={selected_data}
        />
      </PageContainer>
    )
  }
}

export default CustomerContainer
